export const cleanArtistName = (artist) =>
    (artist || "Unknown Artist")
        .replace(/\s*\(\d+\)\s*$/g, "")
        .trim();
